export const SHOW_INVOICE_DETAILS = 'SHOW_INVOICE_DETAILS';
